/**
 * AIOD (All-In-One Discount) cart update bridge for Pursuit theme.
 *
 * AIOD free-gift-manager calls AIOD_handleCartUpdate() after adding gifts.
 * If no supported cart integration is found, it falls back to location.reload().
 * Pursuit uses the cart:rerender event (see promotion.js, diy-cart-accessory-remove.js).
 *
 * Exposing theme.Cart.updateCart lets AIOD refresh the drawer without a full reload.
 */
(function () {
  function installBridge() {
    if (typeof theme === 'undefined' || !theme.Cart) return;
    if (typeof theme.Cart.updateCart === 'function') return;

    theme.Cart.updateCart = function () {
      document.dispatchEvent(new CustomEvent('cart:rerender'));
    };
  }

  installBridge();
  document.addEventListener('AIOD_WASM_LOADED', installBridge);
})();
